import { render, staticRenderFns } from "./TreatmentPicker.vue?vue&type=template&id=c4f9bfe8&scoped=true"
import script from "./TreatmentPicker.vue?vue&type=script&lang=js"
export * from "./TreatmentPicker.vue?vue&type=script&lang=js"
import style0 from "./TreatmentPicker.vue?vue&type=style&index=0&id=c4f9bfe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f9bfe8",
  null
  
)

export default component.exports